import React, { useState, useEffect } from 'react';
import './admin_interface.scss';
import nxtds_icons from '../../dashIcon';
import { __ } from '@wordpress/i18n';
import { nxtdash_save_data, extraOptionsSave } from '../../apicall';
import Components from '../components/components';
const { Nexter_RadioAdvanced, Nexter_Text, Nexter_Color, Nexter_Background, Nexter_Dimension, Nexter_Range, Nexter_Tabs, Nexter_Tab, Nexter_Border, Nexter_Typography, Nexter_BoxShadow, Nexter_Label_Heading, Nexter_Media } = Components;
import Nexter_Icons from '../components/icons'
var plugin_url = nxtext_ajax_object.nxtex_url;
import ProNotice from '../pro-model/pro-notice'
import ExtensionInstallPopup from '../extension_install_pop/ext_install_pop'

let extensionInstall = (nxtext_ajax_object?.dashData?.extensioninstall) ? true : false;

var SettingData = [
    {
        key: 'disable-admin-setting',
        name: __('Disable Admin Settings', 'nexter-extension'),
        popDesc: __('Disable various admin notifications individually.', 'nexter-extension'),
        formField: { key: 'disable-admin-setting', label: __('Hide Admin Notice', 'nexter-extension') },
        doclink: 'https://nexterwp.com/help/nexter-extension/disable-admin-settings-extra-options/'
    },
    {
        key: 'clean-up-admin-bar',
        name: __('Clean Admin Bar', 'nexter-extension'),
        popDesc: __('Remove various elements from the admin bar.', 'nexter-extension'),
        formField: { key: 'clean-up-admin-bar', label: __('Clean Admin Bar', 'nexter-extension') },
        doclink: 'https://nexterwp.com/docs/clean-up-the-wordpress-admin-bar/',
    },
    {
        key: 'wider-admin-menu',
        name: __('Wider Admin Menu', 'nexter-extension'),
        tooltip: __('Set custom admin menu width.', 'nexter-extension'),
        popDesc: __('Adjust the admin menu width to fit wider items.', 'nexter-extension'),
        formField: { key: 'wider-admin-menu', label: __('Wider Admin Menu', 'nexter-extension') },
        doclink: 'https://nexterwp.com/docs/adjust-wordpress-admin-menu-width/',
    },
    {
        key: 'display-plugin-active-first',
        name: __('Display Active Plugins First', 'nexter-extension'),
        tooltip: __('Show active plugins first in the Installed Plugins list', 'nexter-extension'),
        popDesc: __('Show active plugins first in the Installed Plugins list—handy for sites with many deactivated plugins during testing or development.', 'nexter-extension'),
        formField: { key: 'display-plugin-active-first', label: __('Display Active Plugin First', 'nexter-extension') },
        doclink: 'https://nexterwp.com/docs/display-active-plugins-first-in-wordpress/',
        popshow : false,
        isPro : true,
        popdisable : true,
    },
    {
        key: 'clean-user-profile',
        name: __('User Profile Clean', 'nexter-extension'),
        tooltip: __("Remove unnecessary fields from admin profile.", 'nexter-extension'),
        popDesc: __("Customize the admin profile by removing unnecessary fields for a cleaner, more user-friendly interface.", 'nexter-extension'),
        formField: { key: 'clean-user-profile', label: __('User Profile Clean', 'nexter-extension') },
        doclink: 'https://nexterwp.com/docs/clean-user-profile-page-in-wordpress/',
        isPro : true,
    },
    {
        key: 'admin-menu-organizer',
        name: __('WP Admin Menu Organizer', 'nexter-extension'),
        tooltip: __('Customize the admin menu order, rename menu items, or hide them as needed, from the settings under Nexter Extension > Admin Menu.', 'nexter-extension'),
        popDesc: __('Customize the admin menu order, rename menu items, or hide them as needed, from the settings under Nexter Extension > Admin Menu.', 'nexter-extension'),
        formField: { key: 'admin-menu-organizer', label: __('WP Admin Menu Organizer', 'nexter-extension') },
        doclink: 'https://nexterwp.com/docs/organize-wordpress-admin-menu/',
        popshow : false,
        isPro : true,
        popdisable : true,
        isNew : true
    },
];

if(nxtext_ajax_object?.dashData?.elementorplugin){
    SettingData = SettingData.concat([
        {
            key: 'elementor-adfree',
            name: __('Elementor AdFree', 'nexter-extension'),
            tooltip: __('Easily remove unwanted Elementor banners from different areas of your site.', 'nexter-extension'),
            popDesc: __('Easily remove unwanted Elementor banners from different areas of your site.', 'nexter-extension'),
            formField: { key: 'elementor-adfree', label: __('Elementor AdFree', 'nexter-extension') },
            doclink: 'https://nexterwp.com/docs/hide-elementor-banners/',
            isNew : true
        }
    ])
}

var dis_admin_setting = [
    {
        name: __('Hide Frontend Admin Bar', 'nexter-extension'),
        id: 'disable_fadmin_bar',
        tooltip: __('Hide the admin bar from the frontend for all logged-in users.', 'nexter-extension')
    },
    {
        name: __('Hide Themes Update Notifications', 'nexter-extension'),
        id: 'disable_theme_up_noti',
        tooltip: __('Hide theme update notifications in the WordPress backend.', 'nexter-extension')
    },
    {
        name: __('Hide Plugin Update Notifications', 'nexter-extension'),
        id: 'disable_plugin_up_noti',
        tooltip: __('Hide all the plugin update notifications in the WordPress backend.', 'nexter-extension')
    },
    {
        name: __('Hide Core Update Notifications', 'nexter-extension'),
        id: 'disable_core_up_noti',
        tooltip: __('Hide WordPress core update notifications in the WordPress backend.', 'nexter-extension')
    },
    {
        name: __('Hide Admin Notice', 'nexter-extension'),
        id: 'disable_admin_notice',
        tooltip: __('Hide all the additional theme or plugin notifications in the WordPress backend.', 'nexter-extension')
    },
    {
        name: __('Remove ‘PHP Update Required’ Notice', 'nexter-extension'),
        id: 'remove_php_up_notice',
        tooltip: __('Hide the PHP update required notification in the WordPress backend.', 'nexter-extension')
    },
    {
        name: __('Remove Welcome Panel', 'nexter-extension'),
        id: 'remove_admin_panel',
        tooltip: __('Hide the WordPress welcome panel from the backend.', 'nexter-extension')
    },
    {
        name: __('Hide Dashboard Activity', 'nexter-extension'),
        id: 'disable_dashboard_activity',
        tooltip: __('Hide Dashboard Activity Box. (dashboard_activity)', 'nexter-extension')
    },
    {
        name: __('Hide At a Glance', 'nexter-extension'),
        id: 'disable_dashboard_right_now',
        tooltip: __('Hide At a Glance Box. (dashboard_right_now)', 'nexter-extension')
    },
    {
        name: __('Hide Quick Draft', 'nexter-extension'),
        id: 'disable_dashboard_quick_press',
        tooltip: __('Hide Dashboard Quick Draft Box. (dashboard_quick_press)', 'nexter-extension')
    },
    {
        name: __('Hide Site Health Status', 'nexter-extension'),
        id: 'disable_dashboard_site_health',
        tooltip: __('Hide Dashboard Site Health Status Box. (dashboard_site_health)', 'nexter-extension')
    },
    {
        name: __('Hide WooCommerce Setup', 'nexter-extension'),
        id: 'disable_wc_admin_setup',
        tooltip: __('Hide Dashboard WooCommerce Setup Box. (wc_admin_dashboard_setup)', 'nexter-extension')
    },
    {
        name: __('WordPress Events and News', 'nexter-extension'),
        id: 'disable_dashboard_primary',
        tooltip: __('Hide Dashboard WordPress Events and News Box. (dashboard_primary)', 'nexter-extension')
    },
]

var user_profile_setting = [
    {
        name: __('Admin Color Scheme', 'nexter-extension'),
        id: 'user-admin-color-wrap',
    },
    {
        name: __('Toolbar', 'nexter-extension'),
        id: 'user-admin-bar-front-wrap',
    },
    {
        name: __('Biographical Info', 'nexter-extension'),
        id: 'user-description-wrap',
    },
    {
        name: __('Role', 'nexter-extension'),
        id: 'user-role-wrap',
    },
    {
        name: __('Email', 'nexter-extension'),
        id: 'user-email-wrap',
    },
    {
        name: __('New Password', 'nexter-extension'),
        id: 'user-pass1-wrap',
    },
    {
        name: __('Reset Password', 'nexter-extension'),
        id: 'user-generate-reset-link-wrap',
    },
]

var admin_bar_nodes = (nxtext_ajax_object?.dashData?.adminBarNodes && Array.isArray(nxtext_ajax_object.dashData.adminBarNodes)) ? nxtext_ajax_object.dashData.adminBarNodes : [];
var cleanup_adminbar_opt = admin_bar_nodes.length ? admin_bar_nodes.map((node) => ({
    name: node.title || node.id,
    id: node.id,
})) : [
    {
        name: __('Remove WordPress Logo/Menu', 'nexter-extension'),
        id: 'adminbar-wp-logo',
        //tooltip: __('Hide the admin bar from the frontend for all logged-in users.', 'nexter-extension')
    },
    {
        name: __('Remove Home Icon and Site Name', 'nexter-extension'),
        id: 'adminbar-site-name',
    },
    {
        name: __('Remove Customize Menu', 'nexter-extension'),
        id: 'adminbar-customize-menu',
    },
    {
        name: __('Remove Updates Counter/Link', 'nexter-extension'),
        id: 'adminbar-updates-link',
    },
    {
        name: __('Remove Comments Counter/Link', 'nexter-extension'),
        id: 'adminbar-comments-link',
    },
    {
        name: __('Remove New Content Menu', 'nexter-extension'),
        id: 'adminbar-new-content',
    },
    {
        name: __('Remove "Howdy"', 'nexter-extension'),
        id: 'adminbar-howdy',
    },
    {
        name: __('Remove the Help Tab and Drawer', 'nexter-extension'),
        id: 'adminbar-help-tab',
    },
]

var dis_elementor_setting = [
    {
        name: __('Hide Elementor AI banners', 'nexter-extension'),
        id: 'hide_elementor_ai',
        tooltip: __('Hide all Elementor AI notice from backend and Elementor editor.', 'nexter-extension')
    },
    /* {
        name: __('Hide Elementor Send banners', 'nexter-extension'),
        id: 'hide_elementor_send',
        tooltip: __('Dummy Text', 'nexter-extension')
    }, */
    {
        name: __('Hide Elementor Image Optimization Banner', 'nexter-extension'),
        id: 'hide_elementor_imageopt',
        tooltip: __('Hide Elementor Image Optimization notice backend and Elementor editor.', 'nexter-extension')
    },
    /* {
        name: __('Hide Elementor AI "Try Now" and other places', 'nexter-extension'),
        id: 'hide_elementor_trynow',
        tooltip: __('Dummy Text', 'nexter-extension')
    }, */
    {
        name: __('Hide Elementor Pro Ads', 'nexter-extension'),
        id: 'hide_elementor_pro',
        tooltip: __('Hide Elementor Pro banner/notice from backend and Elementor editor.', 'nexter-extension')
    },
]


//if (nxtext_ajax_object.pro) {
    // Concatenate with additional settings
    SettingData = SettingData.concat([
        {
            key: 'wp-login-white-label',
            name: __('Branded WP Admin', 'nexter-extension'),
            popDesc: __('Customize the look and feel of the admin login screen to match your branding.', 'nexter-extension'),
            formField: { key: 'wp-login-white-label', label: __('Enter API Key', 'nexter-extension') },
            // link: { href: '#', text: __('How to Use?', 'nexter-extension') }
            doclink: 'https://nexterwp.com/docs/white-label-wordpress-wp-admin-login-page/',
            isPro : true
        },
    ]);
//}

const Settings = (props) => {
    const [enabledSettings, setEnabledSettings] = useState(() => {
        const extraSettings = nxtext_ajax_object?.dashData?.nxtExtra || {};
    
        // Initialize the settings object
        const defaultSettings = {
            'disable-admin-setting': {
                switch: (extraSettings['disable-admin-setting'] && extraSettings['disable-admin-setting'].switch) ? extraSettings['disable-admin-setting'].switch : false,
                values: []
            },
            'clean-up-admin-bar' : {
                switch: (extraSettings['clean-up-admin-bar'] && extraSettings['clean-up-admin-bar'].switch) ? extraSettings['clean-up-admin-bar'].switch : false,
                values: []
            },
            'wider-admin-menu' : {
                switch: (extraSettings['wider-admin-menu'] && extraSettings['wider-admin-menu'].switch) ? extraSettings['wider-admin-menu'].switch : false,
                values: []
            },
            'clean-user-profile' : {
                switch: (extraSettings['clean-user-profile'] && extraSettings['clean-user-profile'].switch) ? extraSettings['clean-user-profile'].switch : false,
                values: []
            },
            'display-plugin-active-first' : {
                switch: (extraSettings['display-plugin-active-first'] && extraSettings['display-plugin-active-first'].switch) ? extraSettings['display-plugin-active-first'].switch : false,
            },
            'admin-menu-organizer' : {
                switch: (extraSettings['admin-menu-organizer'] && extraSettings['admin-menu-organizer'].switch) ? extraSettings['admin-menu-organizer'].switch : false,
            },
            'wp-login-white-label' : {
                switch: (extraSettings['wp-login-white-label'] && extraSettings['wp-login-white-label'].switch) ? extraSettings['wp-login-white-label'].switch : false,
                values: []
            },
            'elementor-adfree' : {
                switch: (extraSettings['elementor-adfree'] && extraSettings['elementor-adfree'].switch) ? extraSettings['elementor-adfree'].switch : false,
                values: []
            },
        };
    
        // Check if keys are present and merge with defaults
        if (!extraSettings['disable-admin-setting'] || !extraSettings['disable-admin-setting']['values']) {
            extraSettings['disable-admin-setting'] = defaultSettings['disable-admin-setting'];
        }

        if (!extraSettings['clean-up-admin-bar'] || !extraSettings['clean-up-admin-bar']['values']) {
            extraSettings['clean-up-admin-bar'] = defaultSettings['clean-up-admin-bar'];
        }
        
        if (!extraSettings['wider-admin-menu'] || !extraSettings['wider-admin-menu']['values']) {
            extraSettings['wider-admin-menu'] = defaultSettings['wider-admin-menu'];
        }
        
        if (!extraSettings['clean-user-profile'] || !extraSettings['clean-user-profile']['values']) {
            extraSettings['clean-user-profile'] = defaultSettings['clean-user-profile'];
        }

        if (!extraSettings['display-plugin-active-first'] || !extraSettings['display-plugin-active-first']['switch']) {
            extraSettings['display-plugin-active-first'] = defaultSettings['display-plugin-active-first'];
        }
        if (!extraSettings['admin-menu-organizer'] || !extraSettings['admin-menu-organizer']['switch']) {
            extraSettings['admin-menu-organizer'] = defaultSettings['admin-menu-organizer'];
        }
        
        if (!extraSettings['wp-login-white-label'] || !extraSettings['wp-login-white-label']['values']) {
            extraSettings['wp-login-white-label'] = defaultSettings['wp-login-white-label'];
        }
        if (!extraSettings['elementor-adfree'] || !extraSettings['elementor-adfree']['values']) {
            extraSettings['elementor-adfree'] = defaultSettings['elementor-adfree'];
        }

        return {
            ...extraSettings,
        };
    });
    
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isPopupProVisible, setIsPopupProVisible] = useState(false);
    const [isPopupExtensionInstall, setIsPopupExtensionInstall] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupInputValue, setPopupInputValue] = useState({});

    const [device, setDevice] = useState(props.deviceType || 'md');

    const defaultBG = {
        openBg: 1,
        bgType: 'color',
        videoSource: 'local',
        bgDefaultColor: '',
        bgGradient: '',
    }
    const defaultDimension = {
        md: {top: '', bottom: '', left: '', right: ''},
        sm: {top: '', bottom: '', left: '', right: ''},
        xs: {top: '', bottom: '', left: '', right: ''},
        unit: 'px'
    }
    const defaultRange = {
        md: '',
        sm: '',
        xs: '',
        unit: 'px'
    }
    const defaultBorder = {
        openBorder: 0,
        type: '',
        color: '',
        width: {
            md: {top: '', bottom: '', left: '', right: ''},
            sm: {top: '', bottom: '', left: '', right: ''},
            xs: {top: '', bottom: '', left: '', right: ''},unit: 'px'
        },
    }
    const defaultTypo = {
        openTypography: 1,
        size: '',
        height: '',
        spacing: '',
        fontFamily: {},
    }
    const defaultBS = {
        openShadow: false,
        inset:'',
        horizontal: 2,
        vertical: 2,
        blur: 3,
        spread: 0,
        color:'rgba(0, 0, 0, .2)'
    }
    const defaultMedia = {}

    const [settings, setSettings] = useState({

        /* Single Value and Color */
        layoutType: enabledSettings['wp-login-white-label']?.values?.layoutType || 'left',
        fLogoLink: enabledSettings['wp-login-white-label']?.values?.fLogoLink || '',
        formTColor: enabledSettings['wp-login-white-label']?.values?.formTColor || '',
        formTHColor: enabledSettings['wp-login-white-label']?.values?.formTHColor || '',
        formBtnColor: enabledSettings['wp-login-white-label']?.values?.formBtnColor || '',
        formBtnHColor: enabledSettings['wp-login-white-label']?.values?.formBtnHColor || '',
        formFColor: enabledSettings['wp-login-white-label']?.values?.formFColor || '',
        formFHColor: enabledSettings['wp-login-white-label']?.values?.formFHColor || '',
        formLColor: enabledSettings['wp-login-white-label']?.values?.formLColor || '',

        /* Background */
        bodyBG: enabledSettings['wp-login-white-label']?.values?.bodyBG || defaultBG,
        formBoxBG: enabledSettings['wp-login-white-label']?.values?.formBoxBG || defaultBG,
        formBtnBG: enabledSettings['wp-login-white-label']?.values?.formBtnBG || defaultBG,
        formBtnHBG: enabledSettings['wp-login-white-label']?.values?.formBtnHBG || defaultBG,

        /* Dimension */
        formBoxPadding: enabledSettings['wp-login-white-label']?.values?.formBoxPadding || defaultDimension,
        formBRadius: enabledSettings['wp-login-white-label']?.values?.formBRadius || defaultDimension,
        formTBRadius: enabledSettings['wp-login-white-label']?.values?.formTBRadius || defaultDimension,
        formTFBRadius: enabledSettings['wp-login-white-label']?.values?.formTFBRadius || defaultDimension,
        formBtnBRadius: enabledSettings['wp-login-white-label']?.values?.formBtnBRadius || defaultDimension,
        formBtnHBRadius: enabledSettings['wp-login-white-label']?.values?.formBtnHBRadius || defaultDimension,

        /* Range */
        fLogoWidth: enabledSettings['wp-login-white-label']?.values?.fLogoWidth || defaultRange,

        /* Border */
        formBorder: enabledSettings['wp-login-white-label']?.values?.formBorder || defaultBorder,
        formTBorder: enabledSettings['wp-login-white-label']?.values?.formTBorder || defaultBorder,
        formTFBorder: enabledSettings['wp-login-white-label']?.values?.formTFBorder || defaultBorder,
        formBtnBorder: enabledSettings['wp-login-white-label']?.values?.formBtnBorder || defaultBorder,
        formBtnHBorder: enabledSettings['wp-login-white-label']?.values?.formBtnHBorder || defaultBorder,

        /* Typography */
        formTTypo: enabledSettings['wp-login-white-label']?.values?.formTTypo || defaultTypo,
        formBtnTypo: enabledSettings['wp-login-white-label']?.values?.formBtnTypo || defaultTypo,
        formFTypo: enabledSettings['wp-login-white-label']?.values?.formFTypo || defaultTypo,
        formLTypo: enabledSettings['wp-login-white-label']?.values?.formLTypo || defaultTypo,

        /* Box Shadow */
        formBshadow: enabledSettings['wp-login-white-label']?.values?.formBshadow || defaultBS,
        formBtnBshadow: enabledSettings['wp-login-white-label']?.values?.formBtnBshadow || defaultBS,
        formBtnHBshadow: enabledSettings['wp-login-white-label']?.values?.formBtnHBshadow || defaultBS,

        /* Media/Image */
        formLogo: enabledSettings['wp-login-white-label']?.values?.formLogo || defaultMedia
    })

    const handleCheckboxChange = (e, key, opt) => {
        const updateSwitch = { ...enabledSettings }
        // Ensure the key exists with proper structure
        if (!updateSwitch[key]) {
            updateSwitch[key] = { switch: false, values: [] };
        }
        updateSwitch[key]['switch'] = e.target.checked
        setEnabledSettings(updateSwitch)
        /* setEnabledSettings((prevState) => ({
            ...prevState,            
            [key]: {
                ...prevState[key],
                switch: prevState[key]?.switch === true ? false : true, // Safe access with optional chaining
            },
        })); */
        extraOptionsSave(e, key, opt)
    };

    const handleChangeSettings = (dname, newVal) => {
        const newSettings = {
            ...settings,
            [dname]: newVal,
        };

        setSettings(newSettings);

        setEnabledSettings(prevEnabledSettings => ({
            ...prevEnabledSettings,
            'wp-login-white-label': {
                ...prevEnabledSettings['wp-login-white-label'],
                values: newSettings,
            },
        }));
    }

    const changeDupToggle = (val, key, field) => {
        const updatedSettings = { ...enabledSettings };
        // Ensure the field exists with proper structure
        if (!updatedSettings[field]) {
            updatedSettings[field] = { switch: false, values: {} };
        }
        if (!updatedSettings[field].values) {
            updatedSettings[field].values = {};
        }
        updatedSettings[field].values[key] = val;
        setEnabledSettings(updatedSettings); 
    }

    const getAdminBarOptions = () => {
        const legacyOptions = [
            { name: __('Remove WordPress Logo/Menu', 'nexter-extension'), id: 'adminbar-wp-logo' },
            { name: __('Remove Home Icon and Site Name', 'nexter-extension'), id: 'adminbar-site-name' },
            { name: __('Remove Customize Menu', 'nexter-extension'), id: 'adminbar-customize-menu' },
            { name: __('Remove Updates Counter/Link', 'nexter-extension'), id: 'adminbar-updates-link' },
            { name: __('Remove Comments Counter/Link', 'nexter-extension'), id: 'adminbar-comments-link' },
            { name: __('Remove New Content Menu', 'nexter-extension'), id: 'adminbar-new-content' },
            { name: __('Remove "Howdy"', 'nexter-extension'), id: 'adminbar-howdy' },
            { name: __('Remove the Help Tab and Drawer', 'nexter-extension'), id: 'adminbar-help-tab' },
        ];

        const dynamicOptions = (nxtext_ajax_object?.dashData?.adminBarNodes && Array.isArray(nxtext_ajax_object.dashData.adminBarNodes))
            ? nxtext_ajax_object.dashData.adminBarNodes.map((node) => ({ name: node.title || node.id, id: node.id }))
            : [];

        const savedOptions = (enabledSettings && enabledSettings['clean-up-admin-bar'] && Array.isArray(enabledSettings['clean-up-admin-bar'].values))
            ? enabledSettings['clean-up-admin-bar'].values
            : [];

        const merged = [];
        const knownIds = new Set();

        legacyOptions.forEach((option) => {
            if (!knownIds.has(option.id)) {
                knownIds.add(option.id);
                merged.push(option);
            }
        });

        dynamicOptions.forEach((option) => {
            if (!knownIds.has(option.id)) {
                knownIds.add(option.id);
                merged.push(option);
            }
        });

        savedOptions.forEach((id) => {
            if (!knownIds.has(id)) {
                knownIds.add(id);
                merged.push({ id, name: id });
            }
        });

        return merged.length ? merged : cleanup_adminbar_opt;
    }
    
    /* const Drop_down_toggle = (e) => {
        let main_object = e.target.closest(".nxtext_cstm_dropdown")
        let drop_down = main_object.querySelector(".nxtext_cstm_dropdown_content") ? main_object.querySelector(".nxtext_cstm_dropdown_content") : "";
        if (drop_down) {
            if (Object.values(drop_down.classList).includes("nxt_wp_show")) {
                drop_down.classList.remove("nxt_wp_show");
            } else {
                drop_down.classList.add("nxt_wp_show");
            }
        }
    } */

    useEffect(() => {

        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                setIsPopupVisible(false);
                setPopupData(null);
                setPopupInputValue({});
            }
        };

        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, []);

    const handleOpenPopup = (data) => {
        setPopupData(data);
        const initialPopupInputValue = {};
        Object.keys(data.formField).forEach(key => {
            initialPopupInputValue[key] = enabledSettings[key] || '';
        });
        setPopupInputValue(initialPopupInputValue);
        setIsPopupVisible(true);
    };

    const handleClosePopup = () => {
        setIsPopupVisible(false);
        setPopupData(null);
        setPopupInputValue({});
    };

    const handlePopupSave = async (e) => {

        let popWrap = e.target.closest('.nxtext_settings_popup');
        let cardWrap = popWrap.querySelector('.nxtext_field_card_cover');
    
        let getID = cardWrap.getAttribute('id'); 
        if (popupData) {
            setEnabledSettings((prevState) => ({
                ...prevState,
                ...popupInputValue,
            }));

            const formData = new FormData();

            
            formData.append('action', 'nexter_ext_save_data');
            formData.append('extension_type', getID);
            if(getID == 'disable-admin-setting'){
                formData.append('adminHide', JSON.stringify(enabledSettings[getID]?.values || [])); 
            }else if(getID == 'clean-up-admin-bar'){
                formData.append('adminbarClean', JSON.stringify(enabledSettings[getID]?.values || [])); 
            }else if(getID == 'wider-admin-menu'){
                formData.append('adminMenuWidth', JSON.stringify(enabledSettings[getID]?.values || '')); 
            }else if(getID == 'wp-login-white-label'){
                formData.append('wpLoginWL', JSON.stringify(enabledSettings[getID]?.values || {}));
            }else if(getID == 'clean-user-profile' && nxtext_ajax_object.pro){
                formData.append('cleanUserProfile', JSON.stringify(enabledSettings[getID]?.values || []));
            }else if(getID == 'elementor-adfree'){
                formData.append('elementorAdFree', JSON.stringify(enabledSettings[getID].values));
            }
            
            formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
                    
            await nxtdash_save_data(e, formData)
            setTimeout(() => {
                handleClosePopup();    
            }, 300);
        }
    };
    
    const hancdleCheckbox = (e, field) => {
        const updatedSettings = { ...enabledSettings };
        // Ensure the field exists with proper structure
        if (!updatedSettings[field]) {
            updatedSettings[field] = { switch: false, values: [] };
        }
        if (!updatedSettings[field].values) {
            updatedSettings[field].values = [];
        }
        const index = updatedSettings[field].values.indexOf(e.target.value);
        if (e.target.checked && index === -1) {
            updatedSettings[field].values.push(e.target.value);
        } else if (!e.target.checked && index !== -1) {
            updatedSettings[field].values.splice(index, 1);
        }
        setEnabledSettings(updatedSettings);
    }

    const keys = SettingData.map(item => item.key);

    /* const ToggleSettings = ({ field, options }) => (
        <div className='nxtext_pop_in_cover'>
          {options.map((item, index) => (
            <div className='nxtext_strip_tgl_cover' key={index.toString()}>
              <div className='nxtext_strip_tgl_h'>
                <label className='nxtext_paragrph' htmlFor={item.id}>{item.name}</label>
                {item.tooltip && (
                  <div className='nxtext_tooltip'>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span className="nxtext_tooltiptext">{item.tooltip}</span>
                  </div>
                )}
              </div>
              <div className='nxtext_tgl_with_setting'>
                <div className="nxtext_block_tgl_btn_cover">
                <input className="nxtext_toggle_btn" id={item.id} value={item.id} name={"nxt-disable-admin"} type="checkbox" checked={enabledSettings && enabledSettings[field] && enabledSettings[field].values.includes(item.id)} onChange={(e) => { hancdleCheckbox(e, field) }}
                  />
                  <label className="nxtext_switch_label" htmlFor={item.id}>
                    <span className="nxtext_switch_button"></span>
                  </label>
                </div>
              </div>
            </div>
          ))}
        </div>
      ); */
      
    return (
        <div className='nxtext_extopt_cover_main nxtext_main_container'>
            <div className='nxtext_section_heading_cover'>
                <h3 className='nxtext_primary_heading'>{__('Admin Interface', 'nexter-extension')}</h3>
            </div>

            <div className='nxtext_field_card_sec_cover'>
            {SettingData.map((setting, index) => (
                <div className='nxtext_field_card' key={setting.key}>
                    <div className='nxtext_card_top_detail'>
                        <div className='nxtext_field_card_h_strip'>
                            <div className='nxtext_h_with_tip'>
                                <label htmlFor={`nxt_${setting.key}`} className='nxtext_secondary_heading'>{setting.name}</label>
                                {setting.isNew &&
                                    <div className="nxt-new-ext">{ __( "NEW", 'nexter-extension' ) }</div>
                                }
                                <div className='nxtext_tooltip'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                    <span className="nxtext_tooltiptext">{setting.tooltip || setting.popDesc}</span>
                                </div>
                            </div>
                            <div className='nxtext_tgl_with_setting'>
                                {(((setting.popDesc && setting.popshow != false && !setting.isPro) || (nxtext_ajax_object.pro && setting.isPro)) && setting.popdisable != true) &&
                                    <button className={'nxt-ex-btn' + ((enabledSettings && enabledSettings[setting.key] && enabledSettings[setting.key].switch === true) ? ' enabled' : '')} disabled={(enabledSettings && enabledSettings[setting.key] && enabledSettings[setting.key].switch == true) ? false : true} onClick={() => handleOpenPopup(setting)}>{nxtds_icons.setting}</button>
                                }

                                <div className="nxtext_block_tgl_btn_cover">
                                    <input className="nxtext_toggle_btn" id={`nxt_${setting.key}`} type="checkbox" checked={(enabledSettings && enabledSettings[setting.key]?.switch === true && ( (nxtext_ajax_object.pro && setting.isPro) || !setting.isPro )) ? true : false} onChange={(e) => {(extensionInstall && ((!setting.isPro) || (nxtext_ajax_object.pro && setting.isPro))) ? handleCheckboxChange(e, setting.key, "extra") : ''}} onClick={() => { if (!extensionInstall) { setIsPopupExtensionInstall(prev => !prev)}else if (!nxtext_ajax_object.pro && setting.isPro) { setIsPopupProVisible(prev => !prev)} } }  />
                                    <label className={"nxtext_switch_label"+(((!nxtext_ajax_object.pro && setting.isPro) || !extensionInstall) ? ' nxt-pro-lock-toggle' : '')} htmlFor={`nxt_${setting.key}`}>
                                        <span className="nxtext_switch_button"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <p className='nxtext_paragrph'>
                            {setting.desc}
                            {setting.link && <a href={setting.link.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>{setting.link.text}</a>}
                        </p>
                        {setting.doclink &&
                        <div className='nxtext_links_cover'>
                            {/* <a target="_blank" rel="noopener noreferrer" href='#' className='nxtext_tertiary_btn'>{__('Live Demo', 'nexter-extension')}</a> <span>|</span> */}
                            { !( (nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object?.dashData?.whiteLabel?.nxt_help_link == 'on') &&
                                <a target="_blank" rel="noopener noreferrer" href={setting.doclink || '#'} className='nxtext_tertiary_btn nxtext_paragraph'>{__('Read Docs', 'nexter-extension')}</a>
                            }
                        </div>
                        }
                    </div>
                    {!nxtext_ajax_object.pro && setting.isPro &&
                        <div className="nxt-beta-ext">{ __( "PRO", 'nexter-extension' ) }</div>
                    }
                </div>
            ))}
            </div>
            {isPopupVisible &&

                <div>
                    <>
                        <div className='nxtext_overlay' onClick={handleClosePopup}></div>
                        <div className='nxtext_settings_popup'>
                            <svg className='nxtext_close_icon' draggable={false} onClick={handleClosePopup} xmlns="http://www.w3.org/2000/svg" width="36" height="17" fill="none" viewBox="0 0 36 17"><path fill="#414B5A" d="M22.2 4.30665c-.26-.26-.68-.26-.94 0L18 7.55998l-3.26-3.26c-.26-.26-.68-.26-.94 0-.26.26-.26.68 0 .94l3.26 3.26L13.8 11.76c-.26.26-.26.68 0 .94.26.26.68.26.94 0L18 9.43998 21.26 12.7c.26.26.68.26.94 0 .26-.26.26-.68 0-.94l-3.26-3.26002 3.26-3.26c.2533-.25333.2533-.68 0-.93333Z" /></svg>


                            <div className='nxtext_popup_heading'>
                                <h3 className='nxtext_primary_heading'>{popupData.name}</h3>
                                <p className='nxtext_paragrph' dangerouslySetInnerHTML={{ __html: popupData.popDesc }}></p>

                                {/* {popupData.poplink && <a href={popupData.poplink.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>{popupData.poplink.text}</a>} */}

                            </div>
                            <div className='nxtext_popup_inner_main_co'>
                                {Object.keys(popupData.formField).map((key) => {
                                    const field = popupData.formField[key];

                                    if(key == 'label'){
                                        return
                                    }

                                    return (
                                        <div className='nxtext_field_card_cover' key={field} id={field}>

                                            <div className='nxtext_field_card_bottom'>

                                                {field === 'disable-admin-setting' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        {dis_admin_setting.map((item, index) => (
                                                            <div className='nxtext_strip_tgl_cover' key={index.toString()}>
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={item.id}>{item.name}</label>
                                                                    {item.isNew &&
                                                                        <div className="nxt-new-ext">{ __( "NEW", 'nexter-extension' ) }</div>
                                                                    }
                                                                    <div className='nxtext_tooltip'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                                        <span className="nxtext_tooltiptext">{item.tooltip}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='nxtext_tgl_with_setting'>
                                                                    <div className="nxtext_block_tgl_btn_cover">
                                                                        <input className="nxtext_toggle_btn" id={item.id} value={item.id} name={"nxt-disable-admin"} type="checkbox" checked={enabledSettings && enabledSettings[field] && enabledSettings[field].values.includes(item.id)}
                                                                            onChange={(e) => { hancdleCheckbox(e, field) }}/>
                                                                        <label className="nxtext_switch_label" htmlFor={item.id}>
                                                                            <span className="nxtext_switch_button"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {field === 'clean-up-admin-bar' && (

                                                <div className='nxtext_pop_in_cover'>
                                                {getAdminBarOptions().map((item, index) => (
                                                    <div className='nxtext_strip_tgl_cover' key={index.toString()}>
                                                        <div className='nxtext_strip_tgl_h'>
                                                            <label className='nxtext_paragrph nxt-label-full' htmlFor={item.id}>{item.name}</label>
                                                            {item.tooltip && 
                                                                <div className='nxtext_tooltip'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                                <span className="nxtext_tooltiptext">{item.tooltip}</span>
                                                            </div>
                                                            }
                                                        </div>
                                                        <div className='nxtext_tgl_with_setting'>
                                                            <div className="nxtext_block_tgl_btn_cover">
                                                                <input className="nxtext_toggle_btn" id={item.id} value={item.id} name={"nxt-disable-admin"} type="checkbox" checked={enabledSettings && enabledSettings[field] && enabledSettings[field].values.includes(item.id)}
                                                                    onChange={(e) => { hancdleCheckbox(e, field) }}/>
                                                                <label className="nxtext_switch_label" htmlFor={item.id}>
                                                                    <span className="nxtext_switch_button"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                </div>
                                                )}

                                                
                                                
                                                {field === 'wider-admin-menu' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        <Nexter_Range
                                                            label={__('Menu Width', 'nexter-extension')}
                                                            name="menuWidth"
                                                            value={ enabledSettings && enabledSettings[field] && enabledSettings[field].values || ''}
                                                            onChange={ ( value ) => {
                                                                const updatedSettings = { ...enabledSettings };
                                                                if (updatedSettings[field]) {
                                                                    updatedSettings[field].values = value;
                                                                }
                                                                setEnabledSettings(updatedSettings);
                                                            } }
                                                            min={ 140 }
                                                            max={ 500 }
                                                            step={ 20 }
                                                            unit={ ['px'] }
                                                            responsive={ false }
                                                        />
                                                    </div>
                                                )}
                                                
                                                { field == 'wp-login-white-label' &&
                                                    <div className='nxtext_pop_in_cover pop-cover-with-scrollbar'>
                                                        <Nexter_Label_Heading
                                                            label={ __( "Layout", 'nexter-extension' ) }
                                                        />
                                                        <div className='nxtext_strip_tgl_cover cover-full-width'>
                                                            <Nexter_RadioAdvanced
                                                                name="layoutType"
                                                                label={__('Type', 'nexter-extension')}
                                                                value={settings.layoutType || 'left'}
                                                                responsive={false}
                                                                onChange={(value)=>{handleChangeSettings('layoutType', value)}}
                                                                options={ [
                                                                    { label: __('Left', 'nexter-extension'), value: 'left', title: __('Left', 'nexter-extension'), svg: Nexter_Icons.wpleftalign },
                                                                    { label: __('Center', 'nexter-extension'), value: 'center', title: __('Center', 'nexter-extension'), svg: Nexter_Icons.wpcenteralign },
                                                                    { label: __('Right', 'nexter-extension'), value: 'right', title: __('Right', 'nexter-extension'), svg: Nexter_Icons.wprightalign }
                                                                ]  }
                                                                inlineblock={false}
                                                                diff={'left'}
                                                            />
                                                        </div>
                                                        <Nexter_Label_Heading
                                                            label={ __( "Body", 'nexter-extension' ) }
                                                        />
                                                        <div className='nxtext_strip_tgl_cover cover-full-width'>
                                                            <Nexter_Background 
                                                                name="bodyBG"
                                                                label={ __('Background', 'nexter-extension') } 
                                                                sources={ ['color','gradient','image'] } 
                                                                value={ settings['bodyBG'] || defaultBG} 
                                                                onChange={(value)=>{handleChangeSettings('bodyBG', value)}}
                                                                diff={defaultBG}
                                                            />
                                                        </div>
                                                        <Nexter_Label_Heading
                                                            label={ __( "Form", 'nexter-extension' ) }
                                                        />
                                                        <div className='nxtext_strip_tgl_cover cover-full-width'>
                                                            <Nexter_Tabs>
                                                                <Nexter_Tab tabTitle={__('Logo', 'nexter-extension')}>
                                                                    <Nexter_Media
                                                                        label={__('Upload Image', 'nexter-extension')}
                                                                        multiple={false}
                                                                        type={['image']}
                                                                        panel={true}
                                                                        value={settings.formLogo || defaultMedia}
                                                                        onChange={(value) => { handleChangeSettings('formLogo', value) }}
                                                                        diff = { defaultMedia }
                                                                    />
                                                                    <Nexter_Range
                                                                        label={__('Width', 'nexter-extension')}
                                                                        name="fLogoWidth"
                                                                        value={ settings.fLogoWidth || defaultRange}
                                                                        onChange={ ( value ) => {handleChangeSettings('fLogoWidth', value)} }
                                                                        min={ 0 }
                                                                        max={ 1000 }
                                                                        step={ 1 }
                                                                        unit={ ['px', '%'] }
                                                                        responsive={ true }
                                                                        device={ device }
                                                                        onDeviceChange = { ( value ) => setDevice(value) }
                                                                        diff = { defaultRange }
                                                                    />
                                                                    <Nexter_Text
                                                                        label={__('Link', 'nexter-extension')}
                                                                        type={"text"}
                                                                        name="fLogoLink"
                                                                        value={settings.fLogoLink || ''} 
                                                                        onChange={(value)=>{handleChangeSettings('fLogoLink', value)}}
                                                                        dynamic={false}
                                                                        placeholder="http://"
                                                                        className="nxt-full-width"
                                                                        contextId = { '' }
                                                                        inlineblock={false}
                                                                        diff = { '' }
                                                                    />
                                                                </Nexter_Tab>
                                                                <Nexter_Tab tabTitle={__('Box', 'nexter-extension')}>
                                                                    <Nexter_Dimension 
                                                                        label={__('Padding', 'nexter-extension')}
                                                                        name="formBoxPadding"
                                                                        value={settings.formBoxPadding || defaultDimension}
                                                                        openPadding = {true}
                                                                        onChange={ ( value ) => {handleChangeSettings('formBoxPadding', value)} }
                                                                        min= {0}
                                                                        max={100}
                                                                        unit= {['px','%']}
                                                                        responsive={ true }
                                                                        device= {device}
                                                                        onDeviceChange = { ( value ) => setDevice(value) }
                                                                        separator={'after'}
                                                                        diff = { defaultDimension }
                                                                    />
                                                                    <Nexter_Background 
                                                                        name="formBoxBG"
                                                                        label={ __('Background', 'nexter-extension') } 
                                                                        sources={ ['color','gradient','image'] } 
                                                                        value={ settings['formBoxBG'] || defaultBG} 
                                                                        onChange={(value)=>{handleChangeSettings('formBoxBG', value)}}
                                                                        diff={defaultBG}
                                                                    />
                                                                    <Nexter_Border 
                                                                        label={ __('Border', 'nexter-extension') } 
                                                                        name="formBorder"
                                                                        value={ settings.formBorder || defaultBorder} 
                                                                        onChange={ ( value ) => {handleChangeSettings('formBorder', value)} }
                                                                        responsive={ true } 
                                                                        device = { device } 
                                                                        onDeviceChange = { ( value ) => setDevice(value) }
                                                                        separator = {'default'}
                                                                        disableWidthColor = { false }
                                                                        diff={defaultBorder}
                                                                    />
                                                                    <Nexter_Dimension 
                                                                        label={__('Border Radius', 'nexter-extension')}
                                                                        name="formBRadius"
                                                                        value={settings.formBRadius || defaultDimension}
                                                                        openPadding = {true}
                                                                        onChange={ ( value ) => {handleChangeSettings('formBRadius', value)} }
                                                                        min= {0}
                                                                        max={100}
                                                                        unit= {['px','%']}
                                                                        responsive={ true }
                                                                        device= {device}
                                                                        onDeviceChange = { ( value ) => setDevice(value) }
                                                                        separator={'after'}
                                                                        diff = { defaultDimension }
                                                                    />
                                                                    <Nexter_BoxShadow 
                                                                        label={ __('Box Shadow', 'nexter-extension') } 
                                                                        name="formBshadow"
                                                                        value={ settings.formBshadow || defaultBS} 
                                                                        onChange={ ( value ) => {handleChangeSettings('formBshadow', value)} } 
                                                                        separator = {'default'}
                                                                        diff = { defaultBS }
                                                                        istextShadow = { false }
                                                                    />
                                                                </Nexter_Tab>
                                                                <Nexter_Tab tabTitle={__('Field', 'nexter-extension')}>
                                                                    <Nexter_Typography 
                                                                        label={ __('Typography', 'nexter-extension') } 
                                                                        name="formTTypo"
                                                                        value={ settings.formTTypo || defaultTypo}
                                                                        onChange={ ( value ) => {handleChangeSettings('formTTypo', value)} } 
                                                                        device = { device } 
                                                                        onDeviceChange = { ( value ) => setDevice(value) }
                                                                        separator = {'default'}
                                                                        diff = { defaultTypo }
                                                                    />
                                                                    <Nexter_Tabs>
                                                                        <Nexter_Tab tabTitle={__('Normal', 'nexter-extension')}>
                                                                            <Nexter_Color 
                                                                                name="formTColor"
                                                                                label={ __('Text Color', 'nexter-extension') } 
                                                                                disableGlobal ={true}
                                                                                value={settings.formTColor || ''}
                                                                                onChange={(value)=>{handleChangeSettings('formTColor', value)}}
                                                                                separator = {''} 
                                                                                diff={''}
                                                                            />
                                                                            <Nexter_Border 
                                                                                label={ __('Border', 'nexter-extension') } 
                                                                                name="formTBorder"
                                                                                value={ settings.formTBorder || defaultBorder} 
                                                                                onChange={ ( value ) => {handleChangeSettings('formTBorder', value)} }
                                                                                responsive={ true } 
                                                                                device = { device } 
                                                                                onDeviceChange = { ( value ) => setDevice(value) }
                                                                                separator = {'default'}
                                                                                disableWidthColor = { false }
                                                                                diff={defaultBorder}
                                                                            />
                                                                            <Nexter_Dimension 
                                                                                label={__('Border Radius', 'nexter-extension')}
                                                                                name="formTBRadius"
                                                                                value={settings.formTBRadius || defaultDimension}
                                                                                openPadding = {true}
                                                                                onChange={ ( value ) => {handleChangeSettings('formTBRadius', value)} }
                                                                                min= {0}
                                                                                max={100}
                                                                                unit= {['px','%']}
                                                                                responsive={ true }
                                                                                device= {device}
                                                                                onDeviceChange = { ( value ) => setDevice(value) }
                                                                                separator={'after'}
                                                                                diff = { defaultDimension }
                                                                            />
                                                                        </Nexter_Tab>
                                                                        <Nexter_Tab tabTitle={__('Focus', 'nexter-extension')}>
                                                                            <Nexter_Color 
                                                                                name="formTHColor"
                                                                                label={ __('Text Color', 'nexter-extension') } 
                                                                                disableGlobal ={true}
                                                                                value={settings.formTHColor || ''}
                                                                                onChange={(value)=>{handleChangeSettings('formTHColor', value)}}
                                                                                separator = {''} 
                                                                                diff={''}
                                                                            />
                                                                            <Nexter_Border 
                                                                                label={ __('Border', 'nexter-extension') } 
                                                                                name="formTFBorder"
                                                                                value={ settings.formTFBorder || defaultBorder} 
                                                                                onChange={ ( value ) => {handleChangeSettings('formTFBorder', value)} }
                                                                                responsive={ true } 
                                                                                device = { device } 
                                                                                onDeviceChange = { ( value ) => setDevice(value) }
                                                                                separator = {'default'}
                                                                                disableWidthColor = { false }
                                                                                diff={defaultBorder}
                                                                            />
                                                                            <Nexter_Dimension 
                                                                                label={__('Border Radius', 'nexter-extension')}
                                                                                name="formTFBRadius"
                                                                                value={settings.formTFBRadius || defaultDimension}
                                                                                openPadding = {true}
                                                                                onChange={ ( value ) => {handleChangeSettings('formTFBRadius', value)} }
                                                                                min= {0}
                                                                                max={100}
                                                                                unit= {['px','%']}
                                                                                responsive={ true }
                                                                                device= {device}
                                                                                onDeviceChange = { ( value ) => setDevice(value) }
                                                                                separator={'after'}
                                                                                diff = { defaultDimension }
                                                                            />
                                                                        </Nexter_Tab>
                                                                    </Nexter_Tabs>
                                                                </Nexter_Tab>
                                                                <Nexter_Tab tabTitle={__('Button', 'nexter-extension')}>
                                                                    <Nexter_Typography 
                                                                        label={ __('Typography', 'nexter-extension') } 
                                                                        name="formBtnTypo"
                                                                        value={ settings.formBtnTypo || defaultTypo }
                                                                        onChange={ ( value ) => {handleChangeSettings('formBtnTypo', value)} } 
                                                                        device = { device } 
                                                                        onDeviceChange = { ( value ) => setDevice(value) }
                                                                        separator = {'default'}
                                                                        diff = { defaultTypo }
                                                                    />
                                                                    <Nexter_Tabs>
                                                                        <Nexter_Tab tabTitle={__('Normal', 'nexter-extension')}>
                                                                            <Nexter_Color 
                                                                                name="formBtnColor"
                                                                                label={ __('Text Color', 'nexter-extension') } 
                                                                                disableGlobal ={true}
                                                                                value={settings.formBtnColor || ''}
                                                                                onChange={(value)=>{handleChangeSettings('formBtnColor', value)}}
                                                                                separator = {''} 
                                                                                diff={''}
                                                                            />
                                                                            <Nexter_Background 
                                                                                name="formBtnBG"
                                                                                label={ __('Background', 'nexter-extension') } 
                                                                                sources={ ['color','gradient','image'] } 
                                                                                value={ settings['formBtnBG'] || defaultBG} 
                                                                                onChange={(value)=>{handleChangeSettings('formBtnBG', value)}}
                                                                                diff={defaultBG}
                                                                            />
                                                                            <Nexter_Border 
                                                                                label={ __('Border', 'nexter-extension') } 
                                                                                name="formBtnBorder"
                                                                                value={ settings.formBtnBorder || defaultBorder} 
                                                                                onChange={ ( value ) => {handleChangeSettings('formBtnBorder', value)} }
                                                                                responsive={ true } 
                                                                                device = { device } 
                                                                                onDeviceChange = { ( value ) => setDevice(value) }
                                                                                separator = {'default'}
                                                                                disableWidthColor = { false }
                                                                                diff={defaultBorder}
                                                                            />
                                                                            <Nexter_Dimension 
                                                                                label={__('Border Radius', 'nexter-extension')}
                                                                                name="formBtnBRadius"
                                                                                value={settings.formBtnBRadius || defaultDimension}
                                                                                openPadding = {true}
                                                                                onChange={ ( value ) => {handleChangeSettings('formBtnBRadius', value)} }
                                                                                min= {0}
                                                                                max={100}
                                                                                unit= {['px','%']}
                                                                                responsive={ true }
                                                                                device= {device}
                                                                                onDeviceChange = { ( value ) => setDevice(value) }
                                                                                separator={'after'}
                                                                                diff = { defaultDimension }
                                                                            />
                                                                            <Nexter_BoxShadow 
                                                                                label={ __('Box Shadow', 'nexter-extension') } 
                                                                                name="formBtnBshadow"
                                                                                value={ settings.formBtnBshadow || defaultBS } 
                                                                                onChange={ ( value ) => {handleChangeSettings('formBtnBshadow', value)} } 
                                                                                separator = {'default'}
                                                                                diff = { defaultBS }
                                                                                istextShadow = { false }
                                                                            />
                                                                        </Nexter_Tab>
                                                                        <Nexter_Tab tabTitle={__('Hover', 'nexter-extension')}>
                                                                            <Nexter_Color 
                                                                                name="formBtnHColor"
                                                                                label={ __('Text Color', 'nexter-extension') } 
                                                                                disableGlobal ={true}
                                                                                value={settings.formBtnHColor || ''}
                                                                                onChange={(value)=>{handleChangeSettings('formBtnHColor', value)}}
                                                                                separator = {''} 
                                                                                diff={''}
                                                                            />
                                                                            <Nexter_Background 
                                                                                name="formBtnHBG"
                                                                                label={ __('Background', 'nexter-extension') } 
                                                                                sources={ ['color','gradient','image'] } 
                                                                                value={ settings['formBtnHBG'] || defaultBG} 
                                                                                onChange={(value)=>{handleChangeSettings('formBtnHBG', value)}}
                                                                                diff={defaultBG}
                                                                            />
                                                                            <Nexter_Border 
                                                                                label={ __('Border', 'nexter-extension') } 
                                                                                name="formBtnHBorder"
                                                                                value={ settings.formBtnHBorder || defaultBorder} 
                                                                                onChange={ ( value ) => {handleChangeSettings('formBtnHBorder', value)} }
                                                                                responsive={ true } 
                                                                                device = { device } 
                                                                                onDeviceChange = { ( value ) => setDevice(value) }
                                                                                separator = {'default'}
                                                                                disableWidthColor = { false }
                                                                                diff={defaultBorder}
                                                                            />
                                                                            <Nexter_Dimension 
                                                                                label={__('Border Radius', 'nexter-extension')}
                                                                                name="formBtnHBRadius"
                                                                                value={settings.formBtnHBRadius || defaultDimension}
                                                                                openPadding = {true}
                                                                                onChange={ ( value ) => {handleChangeSettings('formBtnHBRadius', value)} }
                                                                                min= {0}
                                                                                max={100}
                                                                                unit= {['px','%']}
                                                                                responsive={ true }
                                                                                device= {device}
                                                                                onDeviceChange = { ( value ) => setDevice(value) }
                                                                                separator={'after'}
                                                                                diff = { defaultDimension }
                                                                            />
                                                                            <Nexter_BoxShadow 
                                                                                label={ __('Box Shadow', 'nexter-extension') } 
                                                                                name="formBtnHBshadow"
                                                                                value={ settings.formBtnHBshadow || defaultBS} 
                                                                                onChange={ ( value ) => {handleChangeSettings('formBtnHBshadow', value)} } 
                                                                                separator = {'default'}
                                                                                diff = { defaultBS }
                                                                                istextShadow = { false }
                                                                            />
                                                                        </Nexter_Tab>
                                                                    </Nexter_Tabs>
                                                                </Nexter_Tab>
                                                                <Nexter_Tab tabTitle={__('Footer', 'nexter-extension')}>
                                                                    <Nexter_Typography 
                                                                        label={ __('Typography', 'nexter-extension') } 
                                                                        name="formFTypo"
                                                                        value={ settings.formFTypo || defaultTypo}
                                                                        onChange={ ( value ) => {handleChangeSettings('formFTypo', value)} } 
                                                                        device = { device } 
                                                                        onDeviceChange = { ( value ) => setDevice(value) }
                                                                        separator = {'default'}
                                                                        diff = { defaultTypo }
                                                                    />
                                                                    <Nexter_Tabs>
                                                                        <Nexter_Tab tabTitle={__('Normal', 'nexter-extension')}>
                                                                            <Nexter_Color 
                                                                                name="formFColor"
                                                                                label={ __('Text Color', 'nexter-extension') } 
                                                                                disableGlobal ={true}
                                                                                value={settings.formFColor || ''}
                                                                                onChange={(value)=>{handleChangeSettings('formFColor', value)}}
                                                                                separator = {''} 
                                                                                diff={''}
                                                                            />
                                                                        </Nexter_Tab>
                                                                        <Nexter_Tab tabTitle={__('Hover', 'nexter-extension')}>
                                                                            <Nexter_Color 
                                                                                name="formFHColor"
                                                                                label={ __('Text Color', 'nexter-extension') } 
                                                                                disableGlobal ={true}
                                                                                value={settings.formFHColor || ''}
                                                                                onChange={(value)=>{handleChangeSettings('formFHColor', value)}}
                                                                                separator = {''} 
                                                                                diff={''}
                                                                            />
                                                                        </Nexter_Tab>
                                                                    </Nexter_Tabs>
                                                                </Nexter_Tab>
                                                                <Nexter_Tab tabTitle={__('Label', 'nexter-extension')}>
                                                                    <Nexter_Typography 
                                                                        label={ __('Typography', 'nexter-extension') } 
                                                                        name="formLTypo"
                                                                        value={ settings.formLTypo || defaultTypo}
                                                                        onChange={ ( value ) => {handleChangeSettings('formLTypo', value)} } 
                                                                        device = { device } 
                                                                        onDeviceChange = { ( value ) => setDevice(value) }
                                                                        separator = {'default'}
                                                                        diff = { defaultTypo }
                                                                    />
                                                                    <Nexter_Color 
                                                                        name="formLColor"
                                                                        label={ __('Text Color', 'nexter-extension') } 
                                                                        disableGlobal ={true}
                                                                        value={settings.formLColor || ''}
                                                                        onChange={(value)=>{handleChangeSettings('formLColor', value)}}
                                                                        separator = {''} 
                                                                        diff={''}
                                                                    />
                                                                </Nexter_Tab>
                                                            </Nexter_Tabs>
                                                        </div>
                                                    </div>
                                                }

                                                {(field === 'clean-user-profile' && nxtext_ajax_object.pro) && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        {user_profile_setting.map((item, index) => (
                                                            <div className='nxtext_strip_tgl_cover' key={index.toString()}>
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={item.id}>{item.name}</label>
                                                                </div>
                                                                <div className='nxtext_tgl_with_setting'>
                                                                    <div className="nxtext_block_tgl_btn_cover">
                                                                        <input className="nxtext_toggle_btn" id={item.id} value={item.id} name={"nxt-disable-admin"} type="checkbox" checked={enabledSettings && enabledSettings[field] && enabledSettings[field].values.includes(item.id)}
                                                                            onChange={(e) => { hancdleCheckbox(e, field) }}/>
                                                                        <label className="nxtext_switch_label" htmlFor={item.id}>
                                                                            <span className="nxtext_switch_button"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {field === 'elementor-adfree' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        {dis_elementor_setting.map((item, index) => (
                                                            <div className='nxtext_strip_tgl_cover' key={index.toString()}>
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={item.id}>{item.name}</label>
                                                                    {item.isNew &&
                                                                        <div className="nxt-new-ext">{ __( "NEW", 'nexter-extension' ) }</div>
                                                                    }
                                                                    <div className='nxtext_tooltip'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                                        <span className="nxtext_tooltiptext">{item.tooltip}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='nxtext_tgl_with_setting'>
                                                                    <div className="nxtext_block_tgl_btn_cover">
                                                                        <input className="nxtext_toggle_btn" id={item.id} value={item.id} name={"nxt-disable-elementor"} type="checkbox" checked={enabledSettings && enabledSettings[field] && enabledSettings[field].values.includes(item.id)}
                                                                            onChange={(e) => { hancdleCheckbox(e, field) }}/>
                                                                        <label className="nxtext_switch_label" htmlFor={item.id}>
                                                                            <span className="nxtext_switch_button"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className={'nxtext_popup_bottom'}>
                                {popupData.doclink &&
                                    <a className='nxtext_tertiary_btn' target="_blank" rel="noopener noreferrer" href={popupData.doclink}>{__('Read How it Works', 'nexter-extension')}</a>
                                }
                                <button className={"nxtext_blue_common_btn"} onClick={(e)=>{handlePopupSave(e)}}>{__('Save', 'nexter-extension')}</button>
                            </div>
                        </div>
                    </>
                </div>
            }
            {isPopupProVisible &&
                <ProNotice isPopupVisible={isPopupProVisible} setIsPopupVisible={setIsPopupProVisible} />
            }
            {isPopupExtensionInstall &&
                <ExtensionInstallPopup isPopupExtensionInstall={isPopupExtensionInstall} setIsPopupExtensionInstall={setIsPopupExtensionInstall} />
            }
        </div>
    );
}

export default Settings;